<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" fill="#722ED1"/>
<path d="M25.2177 23.4782L28.696 20L25.2177 16.5217M14.7829 16.5217L11.3047 20L14.7829 23.4782M22.1743 13.0435L17.8264 26.9565" stroke="white" stroke-width="2.6087" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
